/** Surfaces that exist in the shell but are filled by later slices. 03 flipped notes/capture, 04 schedule, 07 documents/generators. */
export const CONVERSATION_FEATURES = {
  documents: false,
  notes: true,
  schedule: true,
  generators: false,
  capture: true,
} as const;
